import Immutable from "seamless-immutable";
import * as actionTypes from "./actionTypes";

const initialState = Immutable({
  byId: {},
  params: {},
  actionsloading: false,
});
export function queuePDFReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PDF_STATISTICS:
      return {
        ...state,
        // byId: action.payload.byId,
        actionsloading: true,
      };
    case actionTypes.GET_PDF_STATISTICS_SUCCESS:
      return {
        ...state,
        byId: action.payload.sort((a, b) => b.created_at.localeCompare(a.created_at)) || [],
        actionsloading: false,
      };
    default:
      return state;
  }
}
